// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"5c9b8862","591":"3083c3e1","787":"26f8f11a"}[chunkId] + ".chunk.js";
};